import { render, staticRenderFns } from "./Pd3.vue?vue&type=template&id=190b410a&scoped=true"
import script from "./Pd3.vue?vue&type=script&lang=js"
export * from "./Pd3.vue?vue&type=script&lang=js"
import style0 from "./Pd3.vue?vue&type=style&index=0&id=190b410a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b410a",
  null
  
)

export default component.exports